import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

/** Colunas do modelo de importação/exportação de agentes (ida e volta). */
export const AGENTE_EXCEL_HEADERS = [
  'Tipo',
  'RazaoSocial',
  'Fantasia',
  'Pessoa',
  'CnpjCpf',
  'Email',
  'EmailsAdicionais',
  'Telefone',
  'Logradouro',
  'Numero',
  'Complemento',
  'Bairro',
  'Cidade',
  'UF',
  'Cep',
  'CodigoIbgeMunicipio',
  'InscricaoMunicipal',
  'InscricaoEstadual',
  'RetemImpostosFederais',
];

const EXEMPLO = {
  Tipo: 'Cliente',
  RazaoSocial: 'Empresa Exemplo Ltda',
  Fantasia: 'Exemplo',
  Pessoa: 'Juridica',
  CnpjCpf: '00000000000191',
  Email: 'contato@exemplo.com',
  EmailsAdicionais: 'fiscal@exemplo.com,financeiro@exemplo.com',
  Telefone: '11999999999',
  Logradouro: 'Rua Exemplo',
  Numero: '100',
  Complemento: '',
  Bairro: 'Centro',
  Cidade: 'Sao Paulo',
  UF: 'SP',
  Cep: '01001000',
  CodigoIbgeMunicipio: '3550308',
  InscricaoMunicipal: '',
  InscricaoEstadual: '',
  RetemImpostosFederais: 'Nao',
};

function toBool(v) {
  if (typeof v === 'boolean') return v;
  const s = String(v ?? '').trim().toLowerCase();
  return s === 'sim' || s === 'true' || s === '1' || s === 'yes';
}

export function downloadModeloAgentesExcel() {
  const ws = XLSX.utils.json_to_sheet([EXEMPLO], { header: AGENTE_EXCEL_HEADERS });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Agentes');
  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([buf], { type: 'application/octet-stream' }), 'MODELO_IMPORTACAO_AGENTES.xlsx');
}

export function exportAgentesExcel(agentes) {
  const rows = (agentes || []).map((a) => ({
    Tipo: a.tipo || 'Cliente',
    RazaoSocial: a.razaosocial || '',
    Fantasia: a.fantasia || '',
    Pessoa: a.pessoa || '',
    CnpjCpf: a.cnpjcpf || '',
    Email: a.email || '',
    EmailsAdicionais: a.emailsAdicionais || '',
    Telefone: a.telefone || '',
    Logradouro: a.logradouro || '',
    Numero: a.numero || '',
    Complemento: a.complemento || '',
    Bairro: a.bairro || '',
    Cidade: a.cidade || '',
    UF: a.uf || '',
    Cep: a.cep || '',
    CodigoIbgeMunicipio: a.codigoIbgeMunicipio || '',
    InscricaoMunicipal: a.inscricaoMunicipal || '',
    InscricaoEstadual: a.inscricaoEstadual || '',
    RetemImpostosFederais: a.retemImpostosFederais ? 'Sim' : 'Nao',
  }));
  const ws = XLSX.utils.json_to_sheet(rows.length ? rows : [EXEMPLO], { header: AGENTE_EXCEL_HEADERS });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Agentes');
  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([buf], { type: 'application/octet-stream' }), 'agentes_export.xlsx');
}

/** Lê arquivo Excel e devolve linhas no formato CreateAgenteRequest (camelCase API). */
export async function parseAgentesExcelFile(file) {
  const data = await file.arrayBuffer();
  const wb = XLSX.read(data, { type: 'array' });
  const sheet = wb.Sheets[wb.SheetNames[0]];
  const json = XLSX.utils.sheet_to_json(sheet, { defval: '' });
  return json.map((row) => ({
    tipo: row.Tipo || row.tipo || 'Cliente',
    razaosocial: row.RazaoSocial || row.razaosocial || '',
    fantasia: row.Fantasia || row.fantasia || '',
    pessoa: row.Pessoa || row.pessoa || '',
    cnpjcpf: String(row.CnpjCpf || row.cnpjcpf || '').trim(),
    email: row.Email || row.email || '',
    emailsAdicionais: row.EmailsAdicionais || row.emailsAdicionais || '',
    telefone: String(row.Telefone || row.telefone || ''),
    logradouro: row.Logradouro || row.logradouro || '',
    numero: String(row.Numero || row.numero || ''),
    complemento: row.Complemento || row.complemento || '',
    bairro: row.Bairro || row.bairro || '',
    cidade: row.Cidade || row.cidade || '',
    uf: row.UF || row.uf || '',
    cep: String(row.Cep || row.cep || ''),
    codigoIbgeMunicipio: String(row.CodigoIbgeMunicipio || row.codigoIbgeMunicipio || ''),
    inscricaoMunicipal: row.InscricaoMunicipal || row.inscricaoMunicipal || '',
    inscricaoEstadual: row.InscricaoEstadual || row.inscricaoEstadual || '',
    retemImpostosFederais: toBool(row.RetemImpostosFederais ?? row.retemImpostosFederais),
  }));
}
